import * as React from 'react';
import RelatedCollectionForm from "../../components/RelatedCollections/RelatedCollectionForm/RelatedCollectionForm";
var RelatedCollection = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432\u0430 \u0441\u0432\u044A\u0440\u0437\u0430\u043D \u043F\u0440\u043E\u0434\u0443\u043A\u0442"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(RelatedCollectionForm, null))))));
};
export default RelatedCollection;



//////////////////
// WEBPACK FOOTER
// ./src/views/RelatedCollections/RelatedCollection.tsx
// module id = 428
// module chunks = 0